import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from "environments/environment";
import { vGlobal } from '@core/types/cb-global-vars';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

let dialogConfig = new MatDialogConfig();
dialogConfig = {
  width: '1006px',
  height: '550px',
  data: {},
  disableClose: true,
  autoFocus: false,
  panelClass: 'time-session-dialog',
};

@Component({
  selector: "bx-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class FooterComponent implements OnInit, OnDestroy {
  private _unsubscribeFtr: Subject<void> = new Subject();
  hiddenPath: boolean = environment.hiddenPath;
  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------
  @Input() showRecomendations: boolean = false;
  /**
   * Getter for current year
   */
  get currentYear(): number { return new Date().getFullYear(); }
  get version(): string { return environment.version.replace(/[*+?^${}()|[\]\\]/g, ""); }
  numberTel(use: string): string { return (use == '55') ? vGlobal.numberTel55 : vGlobal.numberTel800 }
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  constructor() { }
  /**
   * On init
   */
  ngOnInit(): void { }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeFtr.next();
    this._unsubscribeFtr.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  uriLinks: string[] = [
    'https://cb.vepormas.com.mx/PortalCBnuevo/Nosotros/Faq/Faq.html',
    'https://cb.vepormas.com.mx/PortalCBnuevo/Nosotros/Comisiones/Cuadro_de_Comisiones.pdf',
    'https://www.vepormas.com/fwpf/portal/documents/visualizador-de-archivos?file=aviso-privacidad-casa-de-bolsa-clientes.pdf',
    'https://cb.vepormas.com.mx/PortalCBnuevo/Nosotros/Seguridad/seguridad.html',
    'https://www.vepormas.com/fwpf/portal/documents/llamenme-ahora',
    'https://www.vepormas.com/fwpf/portal/documents/indicadores-cnbv'
  ]
  // -----------------------------------------------------------------------------------------------------
  // Public Methods
  // -----------------------------------------------------------------------------------------------------
  /**
   * goWeb
   * @param idUrl 
   */
  goWeb(idUrl:number) { window.open(this.uriLinks [idUrl], '_blank') }
}